import { Component } from '@angular/core';

@Component({
  standalone: false,
	selector: 'app-sidebar-header',
	templateUrl: './app-sidebar-header.component.html',
	styleUrls: ['./app-sidebar-header.component.scss'],
})
export class AppSidebarHeaderComponent {}
